import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  getItems,
  updateItem,
  deleteItem,
  toggleItemStatus,
} from "../../../api/salesApi";
import { BsThreeDotsVertical } from "react-icons/bs";
import "./SalesTable.css";
import useShopItems from "../../../hooks/useShopItems";
import Pagination from "../../MiniComponents/Pagination";

export default function SalesTable() {
  const navigate = useNavigate();

  const [openMenu, setOpenMenu] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingRow, setEditingRow] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const isFirstLoad = useRef(true);

  const [page, setPage] = useState(1);

  const { getShopItems, totalPages, allShopItems, loadingShopItems } =
    useShopItems();
  const limit = 10;

  useEffect(() => {
    const fetchAllShopItems = async () => {
      const res = await getShopItems(page, limit);
    };
    fetchAllShopItems();
  }, [page, limit]);

  useEffect(() => {
    const stored = localStorage.getItem("lastSeenSalesCount");
    if (stored === null) {
      localStorage.setItem("lastSeenSalesCount", "0");
    }
  }, []);

  const fetchItems = async (category = "snakes") => {
    try {
      setLoading(true);
      const items = await getItems(category);

      setData(items.map((item, idx) => ({ ...item, srn: idx + 1 })));

      const newCount = items.length;
      const lastSeenCount = Number(
        localStorage.getItem("lastSeenSalesCount") || 0,
      );

      if (isFirstLoad.current) {
        localStorage.setItem("lastSeenSalesCount", newCount.toString());
        isFirstLoad.current = false;
        setHasUnreadNotifications(false);
      } else if (newCount > lastSeenCount) {
        setHasUnreadNotifications(true);
      } else {
        setHasUnreadNotifications(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchItems();
  // }, []);

  const handleToggleStatus = async (item) => {
    const newStatus = item.status === "active" ? "inactive" : "active";
    try {
      await toggleItemStatus(item._id, newStatus);
      setData((prev) =>
        prev.map((i) => (i._id === item._id ? { ...i, status: newStatus } : i)),
      );
      setOpenMenu(null);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredData = data.filter(
    (item) =>
      item.itemName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.itemCategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.itemSubCategory.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="sales-table-container">
      <div className="sales-table-inner">
        {/* HEADER */}
        <div className="sales-table-header">
          <div>SRN</div>
          <div>Name</div>
          <div>Category</div>
          <div>Cash</div>
          <div>Coins</div>
          <div>Type</div>
          <div>Added At</div>
        </div>

        {/* BODY */}
        <div className="sales-table-body">
          {loadingShopItems ? (
            <div className="table-message">Loading...</div>
          ) : !loadingShopItems && allShopItems.length === 0 ? (
            <div className="table-message">No items found.</div>
          ) : (
            allShopItems.map((item, index) => (
              <div key={item?._id} className="sales-table-row">
                <div>{(page - 1) * limit + index + 1}</div>
                <div>{item?.name ? item.name : item?.chestType}</div>
                <div>{item?.type}</div>
                <div>{item?.priceCash || item?.chestPrice || "_"}</div>
                <div>{item?.coins || item?.priceCoins || "_"}</div>
                <div>
                  {item?.coins <= 0 || item?.priceCoins <= 0 ? "Free" : "Paid"}
                </div>
                <div className="date">
                  {new Date(item.createdAt).toLocaleString()}
                </div>
                {/* <div>
                  <span
                    className={`status ${
                      item.status === "active" ? "active" : "inactive"
                    }`}
                  >
                    {item.status}
                    
                  </span>
                </div> */}

                {/* <div className="action-cell">
                  <button
                    onClick={() =>
                      setOpenMenu(openMenu === item._id ? null : item._id)
                    }
                    className="menu-btn"
                  >
                    <BsThreeDotsVertical />
                  </button>

                  {openMenu === item._id && (
                    <div className="action-menu">
                      <button onClick={() => handleToggleStatus(item)}>
                        Toggle Status
                      </button>
                    </div>
                  )}
                </div> */}
              </div>
            ))
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "20px",
        }}
      >
        {totalPages > 1 && (
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={(p) => setPage(p)}
          />
        )}
      </div>
    </div>
  );
}
